export const FLAG_GETTING_POSITIONS = 'FLAG_GETTING_POSITIONS';
export const GET_POSITIONS = 'GET_POSITIONS';
export const CLEAR_POSITIONS = 'CLEAR_POSITIONS';
